import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import { UiCrossIcon } from "@jti/brand-icons/ui-cross";
import { useOutsideClick } from "../../../../hooks/useOutsideClick";
import { useTranslations } from "../../../../providers/useTranslations";
import { disableScroll, enableScroll } from "../../../../utils/bodyScrollLock/bodyScrollLock";
import { SearchForm } from "../SearchForm";
import styles from "./SearchHeaderBanner.module.scss";
export const SearchHeaderBanner = ({ isOpened, resultsPageUrl, Container, onClose }) => {
    const searchContainerRef = useRef(null);
    const { __ } = useTranslations();
    useOutsideClick(searchContainerRef, onClose, {
        excludeSelectors: ["[data-search-button]"],
    });
    useEffect(() => {
        if (isOpened) {
            disableScroll();
        }
        else {
            enableScroll();
        }
    }, [isOpened]);
    return (_jsx(CSSTransition, { in: isOpened, timeout: 115, classNames: {
            enter: styles.fadeInFromTop,
            exit: styles.fadeOutToTop,
        }, nodeRef: searchContainerRef, unmountOnExit: true, children: _jsx("div", { className: styles.searchContainer, "data-testid": "searchContainer", ref: searchContainerRef, children: _jsx("div", { className: styles.searchAnimation, children: _jsxs(Container, { children: [_jsxs("div", { className: styles.searchHeader, children: [_jsx("div", { className: styles.searchTitle, children: __("search.title") }), _jsx("button", { type: "button", "aria-label": "close", className: styles.searchClose, onClick: onClose, children: _jsx(UiCrossIcon, {}) })] }), _jsx("div", { className: styles.searchFormWrapper, children: _jsx(SearchForm, { resultsPage: resultsPageUrl }) })] }) }) }) }));
};
//# sourceMappingURL=SearchHeaderBanner.js.map